import actions from "@/store/modules/inventory/actions";
import mutations from "@/store/modules/inventory/mutations";
import state from "@/store/modules/inventory/state";

export default {
    actions,
    mutations,
    state
}